import { MissionData } from '../blocks/mission'
import template from './templates/RJS12.rbxl'
import thumbnail1 from './thumbnails/RJS12/SpawnLocation.png'
import thumbnail2 from './thumbnails/RJS12/BossWall.png'
import thumbnail3 from './thumbnails/RJS12/StartWall.png'
import thumbnail4 from './thumbnails/RJS12/Goal.png'
import thumbnail5 from './thumbnails/RJS12/BossAttack.png'
import thumbnail6 from './thumbnails/RJS12/Block.png'

const mission: MissionData = {
  // Set the template and other metadata.
  // テンプレートとその他のメタデータを設定します。
  number: 2,
  stage: 0,
  thumbnail: '',
  title: '',
  template,
  chapters: [{}, {}, {}, {}, {}, {}],
  objects: [
    {
      name: '①スタートちてん',
      thumbnail: thumbnail1,
    },
    {
      name: '②ボスのかべ',
      thumbnail: thumbnail2,
    },
    {
      name: '③スタートのかべ',
      thumbnail: thumbnail3,
    },
    {
      name: '④ゴール',
      sound: true,
      thumbnail: thumbnail4,
    },
    {
      name: '⑤ボスのこうげき',
      thumbnail: thumbnail5,
    },
    {
      name: '⑥ブロック',
      thumbnail: thumbnail6,
    },
  ],
}

export default mission
